import { configureStore } from "@reduxjs/toolkit";
import thunk from "redux-thunk";
import bookingSlice from "../slice/bookingSlice";
// import logger from "redux-logger";
import filterSlice from "../slice/filterSlice";
import terminalSlice from "../slice/terminalSlice";

const middlewareArray = [thunk];

const getMiddleware = () => {
  if (process.env.NODE_ENV !== "production") {
    return [...middlewareArray];
  }
  return middlewareArray;
};

const store = configureStore({
  reducer: {
    bookings: bookingSlice,
    searchFilter: filterSlice,
    terminal: terminalSlice,
  },
  middleware: (gDM) =>
    gDM({ serializableCheck: false }).concat(
      getMiddleware() as unknown as ReturnType<typeof gDM>
    ),
  devTools: process.env.NODE_ENV !== "production",
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export default store;
